<script>
import WideIconTile from '@/components/WideIconTile'
import VueEditor from '@/components/vue2-editor/VueEditor'
import Button from '@/components/Button'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import FieldsValidator from '@/components/FieldsValidator'
import Collapsible from '@/components/Collapsible'
import ImageEnlarger from '@/components/ImageEnlarger'
import Checkbox from '@/components/Checkbox'
import BackgroundIllustration from '@/components/BackgroundIllustration'
import CameraUtils from '@/utils/cameraUtils'
import FileUtils from '@/utils/fileUtils'
import GeolocationUtils from '@/utils/geolocationUtils'
import ObjectUtils from '@/utils/objectUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import FileReaderUtils from '@/utils/fileReaderUtils'
import LostObjectsService from '@/services/lostObjects'
import StringUtils from '@/utils/stringUtils'

export default
{
    name: 'lost-objects',

    created ()
    {
        this.currentStep = this.steps.selectCase

        LostObjectsService.fetchPublishedLostObjects(EnvironmentUtils.cityId).then(objects =>
        {
            this.$store.commit('lostObjects/updateObjectsList', objects)
        })
    },

    render () 
    {
        const title = this.currentStep.title
        
        return (
            <div id='lost-objects-view'>
                <div id='step-content'>
                    <div class='view-title'>{typeof title == 'function' ? title(this.lostObject) : title}</div>
                    <div v-show={this.currentStep == this.steps.selectCase} id='step-select-case'>
                        <WideIconTile title="J'ai perdu quelque chose" icon={require('@/assets/img/boy-thinking.svg')}
                            on-click={() => this.stepSelectCaseNext('lost')} />
                        <WideIconTile title="J'ai trouvé un objet" icon={require('@/assets/img/cardpaper-box.svg')}
                            on-click={() => this.stepSelectCaseNext('found')} />
                    </div>
                    <div v-show={this.currentStep == this.steps.objectPicture} id='step-object-pictureUrl'>
                        <WideIconTile title='Prendre une photo' icon={require('@/assets/img/camera.svg')}
                            on-click={() => this.stepObjectPictureNext('take')} />
                        <WideIconTile title='Choisir une photo depuis ma galerie' icon={require('@/assets/img/photos.svg')}
                            on-click={() => this.stepObjectPictureNext('select')} />
                        <WideIconTile title='Je ne peux pas fournir de photos' icon={require('@/assets/img/cross-red-circle.svg')}
                            on-click={() => this.stepObjectPictureNext('none')} />
                    </div>
                    <div v-show={this.currentStep == this.steps.objectDescription} id='step-object-description'>
                        <vue-editor v-model={this.lostObject.description} placeholder='Donner une description ici' show-toolbar={false} no-html={true} />
                        <Button text='Continuer' icon={require('@/assets/img/back-thick.svg')} icon-on-right={true} disabled={!this.lostObject.description} on-click={this.nextStep} />
                    </div>
                    <div v-show={this.currentStep == this.steps.objectLocation} id='step-object-location'>
                        <WideIconTile title='Utiliser ma géolocalisation' icon={require('@/assets/img/location-pin.svg')}
                            on-click={() => this.stepObjectLocationNext('geolocation')} />
                        <WideIconTile title='Entrer une adresse' icon={require('@/assets/img/text-typing.svg')} v-model={this.lostObject.location}
                            on-click={() => this.stepObjectLocationNext('type')} />
                        <WideIconTile title='Je ne peux pas fournir cette information' icon={require('@/assets/img/cross-red-circle.svg')}
                            on-click={() => this.stepObjectLocationNext('none')} />
                    </div>
                    <div v-show={this.currentStep == this.steps.objectLocation.subSteps.typeLocation} id='step-object-location-type-location'>
                        <vue-editor v-model={this.lostObject.location} placeholder="Entrer l'adresse ici" show-toolbar={false} no-html={true} />
                        <Button text='Continuer' icon={require('@/assets/img/back-thick.svg')} icon-on-right={true} disabled={!this.lostObject.location} on-click={this.nextStep} />
                    </div>
                    <fields-validator v-show={this.currentStep == this.steps.senderContact} id='step-object-location-type-location' ref='senderContactValidator'>
                        <floating-label-text-input placeholder='Prénom' v-model={this.lostObject.sender.firstName} validation='not-empty' />
                        <floating-label-text-input placeholder='Nom' v-model={this.lostObject.sender.lastName} validation='not-empty' />
                        <floating-label-text-input placeholder='Courriel' v-model={this.lostObject.sender.email} type='email' validation='email' />
                        <floating-label-text-input placeholder='Numéro de téléphone' v-model={this.lostObject.sender.phone} type="tel" validation='phone' />
                        <Button text='Continuer' icon={require('@/assets/img/back-thick.svg')} icon-on-right={true} on-click={this.stepSenderContactNext} />
                    </fields-validator>
                    <div v-show={this.currentStep == this.steps.done} id='step-done'>
                        <inline-svg src={require('@/assets/img/smile.svg')} class='illustration' />
                        <div class='text'>Merci {this.lostObject.sender.firstName}, nous avons bien pris votre signalement en compte et nous nous occupons de la suite.</div>
                        <Button text="D'accord" on-click={() => this.$router.push('/')} />
                    </div>
                </div>
                <div v-show={this.currentStep == this.steps.selectCase} id='published-objects'>
                    <div class='view-title'>Objets publiés</div>
                    {
                        this.objectsList.map(object =>
                        {
                            const desc = <div>
                                <image-enlarger>
                                    <img v-show={!StringUtils.isEmptyString(object.pictureUrl)} class='picture' src={object.pictureUrl} />
                                </image-enlarger>
                                <div class='description'>{object.description}</div>
                            </div>

                            const isFound = object.tags.includes('found')

                            return <collapsible class='published-object-card' title={isFound ? 'Trouvé' : 'Perdu'} description-node={desc}>
                                <div class='actions'>
                                    <Button text={`J'ai ${isFound ? 'perdu' : 'trouvé'} cet objet`} on-click={() => this.onPublishedObjectClaimed(object)}
                                        size='normal' />
                                </div>
                            </collapsible>
                        })
                    }
                    <background-illustration v-show={this.objectsList.length == 0} image={require('@/assets/img/wind-blowing-leaves.svg')} 
                        message={'Aucun objet publié.\nLes prochains objets perdus que nous déciderons d\'afficher apparaîtront ici.'} />
                    <checkbox label='Être notifié des nouveaux objets' v-model={this.$store.state.user.tags.notifiedOnNewPublishedLostObject}
                        on-click={() => this.$store.commit('user/saveTags')} />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            currentStep: null,
            steps:
            {
                selectCase: { title: 'Quel est votre cas ?' },
                objectPicture: { title: 'À quoi ressemble votre objet ?' },
                objectDescription: { title: 'Pouvez-vous décrire cet objet ?' },
                objectLocation:
                {
                    title: o => `Où avez-vous ${o.tags.includes('found') ? 'trouvé' : 'perdu'} cet objet ?`,
                    subSteps:
                    {
                        typeLocation: { title: o => `Quelle est l\'adresse où vous avez ${o.tags.includes('found') ? 'trouvé' : 'perdu'} cet objet ?` }
                    }
                },
                senderContact: { title: 'Comment pouvons-nous vous contacter si besoin ?', validatorRef: null },
                done: { title: '' }
            },
            lostObject:
            {
                tags: [],
                pictureUrl: null,
                description: '',
                location: null,
                sender: { firstName: '', lastName: '', email: '', phone: '' },
                linkedToObjectId: null
            }
        }
    },

    mounted ()
    {
    },

    computed:
    {
        objectsList ()
        {
            return this.$store.state.lostObjects.objectsList.filter(o => o.tags.includes('published')).sort(o => o.id)
        }
    },

    methods:
    {
        nextStep ()
        {
            const parent = ObjectUtils.getPropertyParent(this.currentStep, this.steps)
            const keys = Object.keys(parent)
            const values = Object.values(parent)
            const currentStepIndex = values.indexOf(this.currentStep)

            if (currentStepIndex == -1)
            {
                throw new Error('Step ' + JSON.stringify(this.currentStep) + ' unknown in steps ' + keys)
            }
            else if (currentStepIndex == values.length - 1)
            {
                const upperStep = ObjectUtils.getPropertyParent(parent, this.steps)

                if (upperStep)
                {
                    console.log('Reached end of substeps with', this.currentStep, 'going up to', upperStep)
                    this.currentStep = upperStep
                    
                    return this.nextStep()
                }
                else throw new Error(`Cannot move to next step ${currentStepIndex + 1} reached end (${keys[currentStepIndex]})`)
            }

            this.currentStep = parent[keys[currentStepIndex + 1]]
        },

        nextSubStep ()
        {
            this.currentStep = Object.values(this.currentStep.subSteps)[0]
        },

        /**
         * @param {('lost'|'found')} caseSelected
         */
        stepSelectCaseNext (caseSelected)
        {
            console.assert(['lost', 'found'].includes(caseSelected))

            this.lostObject.tags.push(caseSelected)
            this.nextStep()
        },

        /**
         * @param {('take'|'select'|'none')} caseSelected
         */
        async stepObjectPictureNext (caseSelected)
        {
            console.assert(['take', 'select', 'none'].includes(caseSelected))

            var pictureUrl = null

            if (caseSelected == 'take')
            {
                try
                {
                    pictureUrl = await CameraUtils.capturePictureAsync()
                }
                catch (e)
                {
                    return console.error(e)
                }
            }
            else if (caseSelected == 'select')
            {
                const images = await FileUtils.promptImages()
                if (!images[0]) return

                pictureUrl = await FileReaderUtils.readAsDataURLAsync(images[0])
            }
            else if (caseSelected == 'none')
            {
                // ..
            }

            this.lostObject.pictureUrl = pictureUrl
            this.nextStep()
        },

        /**
         * @param {('geolocation'|'type'|'none')} caseSelected
         */
        async stepObjectLocationNext (caseSelected)
        {
            console.assert(['geolocation', 'type', 'none'].includes(caseSelected))

            if (caseSelected == 'geolocation')
            {
                try
                {
                    window.app.showFullscreenSpinner = true
                    await GeolocationUtils.requestHightAccuracyGeolocationAsync()
                    await GeolocationUtils.getCurrentPositionAsync().then(location =>
                    {
                        this.lostObject.location = GeolocationUtils.coordsToString(location.coords)
                        window.app.showFullscreenSpinner = false
                        this.nextStep()
                    })
                    .catch(err =>
                    {
                        console.error('Could not fetch geolocalization', err)
                        window.app.showFullscreenSpinner = false
                    })

                }
                catch (error)
                {
                    console.error(error)
                    this.currentStep = this.steps.objectLocation
                    this.$toast.warning('Nous ne pouvons pas accéder à votre géolocalisation. Veuillez réessayer ou entrer une adresse manuellement.', { duration: 5000 })
                }
            }
            else if (caseSelected == 'type')
            {
                this.nextSubStep()
            }
            else if (caseSelected == 'none')
            {
                this.nextStep()
            }
        },

        stepSenderContactNext (e, button)
        {
            if (!this.$refs.senderContactValidator.validate()) return
    
            button.showSpinnerWhile(async () =>
            {
                const created = await LostObjectsService.createLostObjectReport(this.lostObject, EnvironmentUtils.cityId)
                await this.$store.commit('lostObjects/updateObjectsList', created)
                this.nextStep()
            })
        },

        onPublishedObjectClaimed (object)
        {
            this.lostObject.linkedToObjectId = object.id
            this.lostObject.tags.push(object.tags.includes('lost') ? 'found' : 'lost')
            this.lostObject.pictureUrl = object.pictureUrl
            this.lostObject.description = object.description

            if (!this.lostObject.pictureUrl)
            {
                this.currentStep = this.steps.objectPicture
            }
            else this.currentStep = this.steps.objectDescription
        }
    },

    components:
    {
        WideIconTile,
        VueEditor,
        Button,
        FloatingLabelTextInput,
        FieldsValidator,
        Collapsible,
        ImageEnlarger,
        Checkbox,
        BackgroundIllustration
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#lost-objects-view
{
    margin-top: 15vw;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .view-title
    {
        font-weight: 700;
        font-size: 25px;
        margin-left: 8px;
        margin-right: 15%;
        margin-bottom: 20px;

        .OnDesktop({ margin-right: 0; });
    }

    > #step-content
    {
        margin-left: 10px;
        margin-right: 10px;

        .wide-icon-tile
        {
            margin-bottom: 10px;

            .icon
            {
                // .WidthHeight(80px);
            }
        }

        .vue-editor
        {
            background-color: var(--theme-content-background-color);

            .ql-editor
            {
                min-height: 120px;
            }
        }

        .floating-label-text-input
        {
            &:not(:first-of-type)
            {
                margin-top: 10px;
            }
        }

        .button
        {
            width: 100%;
            margin-top: 20px;

            .icon
            {
                transform: rotate(180deg);
            }
        }

        > #step-select-case
        {
            display: flex;
            flex-direction: column;

            > .choice
            {
                display: flex;
                flex-direction: row;
                align-items: start;
                background-color: var(--theme-content-background-color);
                width: -webkit-fill-available;
                padding: 10px 20px;
                border-radius: 6px;
                border: 1px solid var(--theme-border-color-strong);
                box-shadow: var(--theme-box-shadow-soft);
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 10px;

                &:first-of-type
                {
                    margin-top: 0px
                }

                > .icon
                {
                    .WidthHeight(100px);

                    svg
                    {
                        .WidthHeight(100%);
                    }
                }

                > .description
                {
                    font-size: 17px;
                    font-weight: 600;
                    margin-top: 25px;
                    margin-left: 30px;
                }
            }
        }

        #step-done
        {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            & .illustration
            {
                .WidthHeight(150px);
                margin-top: 10%;
            }

            & .text
            {
                width: 95%;
                text-align: center;
                margin-top: 30px;
                font-size: 18px;
                color: var(--theme-text-color-extra-light);
            }

            & .button
            {
                margin-top: 40px;
            }
        }
    }

    #published-objects
    {
        margin: 0 10px;
        margin-top: 20px;

        .published-object-card
        {
            margin: 10px 0;
            background-color: var(--theme-content-background-color);
            width: -webkit-fill-available;
            box-shadow: var(--theme-box-shadow-sharp);

            &:first-of-type
            {
                margin-top: 30px;
            }

            .title
            {
                font-weight: 600;
                font-size: 20px;
            }

            .picture
            {
                width: 100%;
                object-fit: contain;
                max-height: 150px;

                .OnLargeMobile({ max-height: 200px; });
            }

            .actions
            {
                display: flex;
                flex-direction: column;
                margin-top: 15px;

                .OnDesktop({ flex-direction: row; });

                .button
                {
                    width: -webkit-fill-available;

                    &:not(:first-of-type)
                    {
                        margin-top: 5px;

                        .OnDesktop({ margin-top: 0; });
                    }
                }
            }
        }

        .checkbox
        {
            margin-top: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LostObjects.vue